/* eslint-disable */
import { Form, Row, Col, Select } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  selectTipoHallazgoByIdMonitoreo,
  selectCatalogByName
} from 'selectors/catalogos.selectors';
import { MONITOREOS_ESPECTACULARES } from 'constants/tipoMonitoreos';
import { ATRIBUTOS } from 'constants/nombresCatalogos';
import * as fieldMsgs from 'constants/formFieldsMessages';
import * as actasService from '../../../../services/espectacularesActas';

const TipoHallazgo = ({ form, catIdIne, actualizaTipoHallazgo }) => {
  const tipoHallazgos = useSelector(selectTipoHallazgoByIdMonitoreo(MONITOREOS_ESPECTACULARES));

  const renderIdIne = async (e) => {
    const peticion = {
      idINE: ''
    };
    peticion.idINE = e;
    const { data } = await actasService.idIneEspesifico(peticion);
    form.setFieldsValue({
      // Datos hallazgo
      idTipoMedida: undefined,
      medida: data.datos.medida,
      municipio: data.datos.municipio,
      colonia: data.datos.colonia,
      calle: data.datos.calle,
      numeroExterior: data.datos.numExterior,
      cp: data.datos.codigoPostal
    });
  };

  const atributosHallazgos = useSelector(selectCatalogByName(ATRIBUTOS));

  const findAtributoByName = (nombreAtributo) => {
    const idAtributo = atributosHallazgos.find(
      (atributo) => atributo.atributo === nombreAtributo
    )?.idAtributo;
    return idAtributo.toString();
  };

  const updateTipoHallazgo = async () =>
  {
    try 
    {
      actualizaTipoHallazgo();
    } catch (error) 
    {
      console.log('Error: ', error);  
    }
  }

  return (
    <Form form={form} layout="vertical">
      <Row style={{ minWidth: '400px' }}>
        <Col flex="auto">
          <Form.Item
            name="hallazgo"
            label="Hallazgo:"
            rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
            <Select
              fieldNames={{ value: 'idHallazgo', label: 'nombreHallazgo' }}
              optionFilterProp="children"
              placeholder="Selecciona"
              allowClear
              options={tipoHallazgos}
              filterOption={(inputValue, option) =>
                option.nombreHallazgo?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
              }
              showSearch
              onChange = { updateTipoHallazgo }
            />
          </Form.Item>
        </Col>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, curValues) => {
            return prevValues.hallazgo !== curValues.hallazgo;
          }}>
          {() => {
            const listaAtributos =
              tipoHallazgos
                .find((tipo) => tipo.idHallazgo === form.getFieldsValue()?.hallazgo)
                ?.atributos?.split(',') || [];

            const atributosInputs = [];
            atributosInputs.push(
              <Col flex="50%" push={1}>
                {listaAtributos.includes(findAtributoByName('idINE')) && (
                  <Form.Item
                    name="idIne"
                    label="ID INE:"
                    rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                    <Select
                      fieldNames={{ value: 'idINE', label: 'idINE' }}
                      optionFilterProp="children"
                      placeholder="Filtra"
                      allowClear
                      onChange={(e) => renderIdIne(e)}
                      showSearch
                      options={catIdIne}
                      filterOption={(input, option) =>
                        (option?.idINE ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                )}
              </Col>
            );

            return atributosInputs;
          }}
        </Form.Item>
        <Col span={1} />
      </Row>
    </Form>
  );
};

TipoHallazgo.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func,
    validateFields: PropTypes.func
  }).isRequired,
  catIdIne: PropTypes.number.isRequired
};

export default TipoHallazgo;
